import { ButtonGroup, Modal, PrimaryButton, Text } from "@nulogy/components";
import React from "react";
import styled from "styled-components";
import ModalFooter from "../../common/ModalFooter";
import Checkbox from "../../controls/Checkbox";
import DateRange from "../../controls/DateRange";
import Form from "../../controls/Form";

// This is a hack to fix an NDS bug which moved the "-" in DateRange to the wrong location

const DateRangeWrapper = styled.div`
  div {
    max-height: none;
  }
`;
export default function ExportModal({ isExportScheduleModalOpen, setExportScheduleModalOpen, onExport }) {
  const defaultFromDate = new Date();
  defaultFromDate.setHours(0, 0, 0, 0);

  return (
    <Modal
      ariaHideApp={false}
      isOpen={isExportScheduleModalOpen}
      onRequestClose={() => {
        setExportScheduleModalOpen(false);
      }}
      title="Export schedule"
    >
      <Form
        id="exportSchedule"
        initialValues={{ dateRange: { endDate: null, startDate: defaultFromDate }, includeUnavailability: false }}
        onSave={onExport}
      >
        {({ errors }) => (
          <>
            <DateRangeWrapper>
              <DateRange
                defaultStartDate={defaultFromDate}
                endDateInputProps={{
                  dateFormat: "MMM d, yyyy",
                  labelText: (
                    <Text>
                      To{" "}
                      <Text fontWeight="normal" inline>
                        (optional)
                      </Text>
                    </Text>
                  ),
                  name: "toDate",
                }}
                field="dateRange"
                startDateInputProps={{
                  dateFormat: "MMM d, yyyy",
                  labelText: <Text>From</Text>,
                  name: "fromDate",
                  required: true,
                }}
              />
            </DateRangeWrapper>
            <Checkbox
              field="includeUnavailability"
              labelText="Include unavailable shifts"
              name="includeUnavailability"
              pb="x2"
            />
            <ModalFooter>
              <ButtonGroup>
                <PrimaryButton
                  className="pendo-export-button"
                  disabled={errors.dateRange}
                  form="exportSchedule"
                  mr="x1"
                  type="submit"
                >
                  Export
                </PrimaryButton>
              </ButtonGroup>
            </ModalFooter>
          </>
        )}
      </Form>
    </Modal>
  );
}
